import { Column } from 'react-table';

export interface SeoDataFilter {
    entityTypes: string[];
}

export interface SeoDataNew {
    id?: string;
    entityType: string;
    entityUrl: string;
    seoTitle: string;
    seoDescription: string;
    seoKeywords: string;
}

export interface SeoDataSummary {
    id: string;
    entityType: string;
    entityUrl: string;
    seoTitle: string;
    updatedAt: number[];
}

export interface SeoDataDetails {
    id: string;
    entityType: string;
    entityUrl: string;
    seoTitle: string;
    seoDescription: string;
    seoKeywords: string;
    updatedAt: number[];
    createdAt: number[];
}

export type PaginatedSeoSummary = {
    items: SeoDataSummary[];
    total: number;
};

export enum SeoEntityType {
    LECTURE = 'LECTURE',
    PROBLEM = 'PROBLEM',
    MODULE = 'MODULE',
    USER = 'USER',
    STATIC_PAGE = 'STATIC_PAGE',
    CMS_PAGE = 'CMS_PAGE',
}

export const allSeoColumnsAdmin: ReadonlyArray<Column> = [
    {
        Header: 'ID',
        accessor: 'id_short',
    },
    {
        Header: 'Type',
        accessor: 'entityType',
    },
    {
        Header: 'Url',
        accessor: 'entityUrl',
    },
    {
        Header: 'Title',
        accessor: 'seoTitle',
    },
    {
        Header: 'Updated',
        accessor: 'updated_at',
    },
    {
        Header: 'Editare',
        accessor: 'actions',
    },
];
